// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import {Layout, Row, Col, Icon, Avatar, Menu, Form, FormModel, Button, Input, InputNumber, Space, Modal, List,
  Card, Tree, Select, Spin, Notification, Message, Divider, PageHeader, Timeline, Dropdown, Alert, Popconfirm,
  Tooltip, Drawer} from 'ant-design-vue'

import vuescroll from 'vuescroll'

Vue.use(Form)
Vue.use(FormModel)
Vue.use(Button)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Space)
Vue.use(Modal)
Vue.use(List)
Vue.use(Card)
Vue.use(Layout)
Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Avatar)
Vue.use(Menu)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Spin)
Vue.use(PageHeader)
Vue.use(Divider)
Vue.use(Timeline)
Vue.use(Dropdown)
Vue.use(Alert)
Vue.use(Message)
Vue.use(Popconfirm)
Vue.use(Tooltip)
Vue.use(Drawer)
Vue.use(vuescroll)

Vue.prototype.$notification = Notification
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$warning = Modal.warning
Vue.prototype.$message = Message
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js